import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    color: theme.palette.secondary.dark,
    display: 'flex',
  },
  text: {
    marginTop: `${theme.spacing(4)} !important`,
  },
  iconButton: {
    height: '100%', /* fixes "tall" button in flex container */
    marginTop: `${theme.spacing(-2)} !important`,
    marginBottom: `${theme.spacing(-2)} !important`,
    marginLeft: `${theme.spacing(2)} !important`,
    color: `${theme.palette.secondary.dark} !important`,
  },
  subheaderSubtitleSeparator: {
    display: 'inline-block',
    margin: theme.spacing(0, 1),
    '&::before': {
      content: '"·"',
    },
  },
  placeholder: {
    opacity: '0.6',
  },
  hint: {
    color: 'rgba(0, 0, 0, 0.55)',
  },
  ratePart: {
    display: 'flex',
    alignItems: 'top',
  },
  rates: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      alignItems: 'top',
      '& > *:not(:first-child)': {
        paddingLeft: theme.spacing(2),
      },
      '& > *:not(:last-child)': {
        paddingRight: theme.spacing(2),
        borderRight: '1px solid rgba(0, 0, 0, 0.08)',
      },
    },
  },
}))
